<template>
  <section class="page-card">
    <div class="page-head">
      <h1 class="page-title">{{ $t('pages.playerTopup') }}</h1>
      <div class="wallet-balance">
        <span>{{ $t('wallet.topupBalance') }}</span>
        <strong>{{ wallet.topup_balance || '0' }} {{ wallet.currency_code || '' }}</strong>
      </div>
      <el-button type="primary" @click="visible = true">{{ $t('topup.apply') }}</el-button>
    </div>

    <div class="filter-bar">
      <el-input v-model.trim="search.order_no" :placeholder="$t('common.orderId')" class="filter-item"></el-input>
      <el-input v-model.trim="search.target_user_id" :placeholder="$t('topup.playerId')" class="filter-item"></el-input>
      <el-date-picker v-model="search.created_at__gte" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.start')" class="filter-item"></el-date-picker>
      <el-date-picker v-model="search.created_at__lt" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.end')" class="filter-item"></el-date-picker>
      <el-button type="primary" @click="reload">{{ $t('actions.search') }}</el-button>
    </div>

    <div class="table-scroll">
      <el-table :key="tableLanguage" :data="rows" border stripe>
        <el-table-column prop="order_no" :label="$t('common.orderId')" min-width="180"></el-table-column>
        <el-table-column prop="target_user_id" :label="$t('topup.playerId')" min-width="110"></el-table-column>
        <el-table-column prop="user_amount" :label="$t('topup.playerAmount')" min-width="120"></el-table-column>
        <el-table-column prop="user_currency" :label="$t('common.currency')" min-width="90"></el-table-column>
        <el-table-column prop="agent_amount" :label="$t('topup.agentAmount')" min-width="130"></el-table-column>
        <el-table-column prop="agent_currency" :label="$t('common.currency')" min-width="90"></el-table-column>
        <el-table-column prop="exchange_rate" :label="$t('topup.rate')" min-width="120"></el-table-column>
        <el-table-column prop="created_at" :label="$t('topup.successTime')" min-width="165"></el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadOrders"
    ></el-pagination>

    <el-dialog :title="$t('topup.apply')" :visible.sync="visible" width="620px" @closed="resetDialog">
      <el-form label-width="170px">
        <el-form-item :label="$t('topup.playerId')">
          <el-input v-model.number="form.target_user_id"></el-input>
        </el-form-item>
        <el-form-item :label="$t('topup.playerAmount')">
          <el-input-number
            v-model="form.amount"
            :min="1"
            :step="1"
            :precision="0"
            step-strictly
          ></el-input-number>
        </el-form-item>
      </el-form>

      <div v-if="preview" class="preview-card">
        <div><span>{{ $t('topup.playerName') }}</span><strong>{{ preview.user_name || '-' }}</strong></div>
        <div><span>{{ $t('common.phone') }}</span><strong>{{ preview.phone || '-' }}</strong></div>
        <div><span>{{ $t('common.email') }}</span><strong>{{ preview.email || '-' }}</strong></div>
        <div><span>{{ $t('topup.rate') }}</span><strong>{{ preview.exchange_rate }}</strong></div>
        <div><span>{{ $t('topup.agentAmount') }}</span><strong>{{ preview.agent_amount }} {{ preview.agent_currency }}</strong></div>
        <div><span>{{ $t('topup.playerAmount') }}</span><strong>{{ preview.user_amount }} {{ preview.user_currency }}</strong></div>
        <div><span>{{ $t('topup.currentBalance') }}</span><strong>{{ preview.topup_balance }} {{ preview.agent_currency }}</strong></div>
      </div>

      <span slot="footer">
        <el-button :loading="previewing" :disabled="submitting" @click="previewOrder">{{ $t('topup.preview') }}</el-button>
        <el-button type="primary" :disabled="!preview" :loading="submitting" @click="submit">{{ $t('topup.confirm') }}</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'PlayerTopup',
  data() {
    return {
      wallet: {},
      rows: [],
      count: 0,
      search: {
        page: 1,
        size: 20,
        order_no: '',
        target_user_id: '',
        created_at__gte: '',
        created_at__lt: ''
      },
      visible: false,
      previewing: false,
      submitting: false,
      preview: null,
      form: {
        target_user_id: null,
        amount: 1
      }
    };
  },
  computed: {
    tableLanguage() {
      return this.$i18nState.language;
    }
  },
  watch: {
    'form.target_user_id'() {
      this.preview = null;
    },
    'form.amount'() {
      this.preview = null;
    }
  },
  created() {
    this.loadWallet();
    this.loadOrders();
  },
  methods: {
    buildQueryParams() {
      return Object.keys(this.search).reduce((params, key) => {
        const value = this.search[key];
        if (value !== '' && value !== null && value !== undefined) params[key] = value;
        return params;
      }, {});
    },
    reload() {
      this.search.page = 1;
      this.loadOrders();
    },
    resetDialog() {
      this.preview = null;
      this.form = { target_user_id: null, amount: 1 };
    },
    async loadWallet() {
      const resp = await this.$axios.get('/admin/exagent/console/wallet/');
      if (resp.data.status === 0) this.wallet = resp.data.data || {};
    },
    async loadOrders() {
      const resp = await this.$axios.get('/admin/exagent/console/funds/topup/orders/', {
        params: this.buildQueryParams()
      });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.rows = data.list || [];
      this.count = data.count || 0;
    },
    async previewOrder() {
      this.previewing = true;
      this.preview = null;
      try {
        const resp = await this.$axios.get('/admin/exagent/console/funds/topup/player/', {
          params: {
            target_user_id: Number(this.form.target_user_id),
            amount: Number(this.form.amount)
          }
        });
        if (resp.data.status === 0) this.preview = resp.data.data || null;
      } finally {
        this.previewing = false;
      }
    },
    successMessage(data) {
      return [
        `${this.$t('topup.agentAmount')}: ${data.agent_amount} ${data.agent_currency}`,
        `${this.$t('topup.playerAmount')}: ${data.user_amount} ${data.user_currency}`,
        `${this.$t('topup.rate')}: ${data.exchange_rate}`,
        `${this.$t('topup.remainingBalance')}: ${data.topup_balance} ${data.agent_currency}`
      ].join('\n');
    },
    async submit() {
      this.submitting = true;
      try {
        const resp = await this.$axios.post('/admin/exagent/console/funds/topup/apply/', {
          target_user_id: Number(this.form.target_user_id),
          amount: Number(this.form.amount)
        });
        if (resp.data.status !== 0) return;
        const data = resp.data.data || {};
        this.$alert(this.successMessage(data), data.order_no || this.$t('topup.successTitle'), {
          confirmButtonText: this.$t('actions.confirm')
        }).catch(() => {});
        this.visible = false;
        this.preview = null;
        await Promise.all([this.loadWallet(), this.loadOrders()]);
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.page-head,
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.page-head h1 {
  flex: 1;
}
.wallet-balance {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.wallet-balance span,
.preview-card span {
  color: #66788a;
  font-size: 13px;
}
.filter-item {
  width: 180px;
}
.preview-card {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #f8fafc;
}
.preview-card div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/PlayerTopup.vue